export default __webpack_public_path__ + "static/media/leadership-involvement-2.333db000.svg";